"use client";
import React, { useState } from "react";
import dayjs from "dayjs";
import {
  Alert,
  Button,
  Col,
  Divider,
  List,
  Row,
  Space,
  Typography,
} from "antd";

import TimeButton from "../../../../components/TimeButton";
import { DB_DATE_FORMAT } from "@/consts";
import { EditionJson } from "@/lib/api";
import { UserData, UserOpeningsData, ServiceOption } from "@/lib/api/types";
import OpeningLoading from "@/app/components/OpeningLoading";
import { AppointmentForm } from "@/lib/hooks/useAppointment";
import { CalendarOutlined } from "@ant-design/icons";
import Paragraph from "antd/lib/typography/Paragraph";

interface IProps {
  userId: string;
  userPathName: string;
  userName: string;
  date: string;
  services: (UserData["services"][number] & { option?: ServiceOption })[];
  duration: number;
  onTimeClick: (args: AppointmentForm) => void;
  onRefresh?: () => void;
}

const DisplayNextOpenings = ({
  userId,
  userPathName,
  userName,
  date,
  duration,
  services,
  onTimeClick,
  onRefresh,
}: IProps) => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState<(UserOpeningsData & { date: string })[]>([]);

  const onSearch = async () => {
    let _date = date;
    if (dayjs(date).isSame(dayjs(), "day")) {
      _date = dayjs(date).add(1, "days").format(DB_DATE_FORMAT);
    }

    setLoading(true);
    try {
      const res = await EditionJson.getUserNextOpeningsByDuration(
        userPathName,
        _date,
        duration
      );
      setData(res);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  if (isLoading) {
    return <OpeningLoading />;
  }

  return (
    <>
      {data.length > 0 ? (
        <>
          {data.map((item: any, i: number) => {
            return (
              <List key={item.date}>
                <List.Item>
                  <List.Item.Meta
                    description={
                      <>
                        <Space className="pb-1">
                          <Typography.Text strong>{item.date}</Typography.Text>
                          <Divider type="vertical" />
                          <Typography.Text type="secondary">
                            {item.schedule.locationName}
                          </Typography.Text>
                        </Space>

                        <Row gutter={[8, 8]}>
                          {item.openings.map((time: string, i: number) => {
                            return (
                              <Col key={`${time}-${i}`} span={8}>
                                <TimeButton
                                  onClick={() => {
                                    onTimeClick({
                                      userId,
                                      stylistName: userName,
                                      scheduleId: item.schedule._id,
                                      locationName: item.schedule.locationName,
                                      services,
                                      time,
                                      date: item.date,
                                    });
                                  }}
                                  time={time}
                                  isSelected={false}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </>
                    }
                  ></List.Item.Meta>
                </List.Item>
              </List>
            );
          })}
        </>
      ) : (
        <div style={{border: "1px solid #000", padding: "16px", borderRadius: "8px"}}>
          <Paragraph>
            No openings found for this date. Check availability on other days.
          </Paragraph>
          <Button color="default" variant="solid" icon={<CalendarOutlined />} type="primary" onClick={onSearch}>
            Next Availability
          </Button>
        </div>
      )}
    </>
  );
};

export default DisplayNextOpenings;
